import { debounce, mergeWith, isArray } from 'lodash-es'

/**
 * 使用方法见最后
 */

/**
 * 如何合并数组
 */
function customMergeArray(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue)
  }
}

/**
 * 合并多个请求为一次请求，merge参数在一个请求内
 */
export const mergeRequest = (requestApi, wait = 100, maxWait = 125) => {
    if (typeof requestApi !== 'function') throw new Error('需要传递一个函数')
    let waitRequestList = []
    let mergeData = {}

    // 真实请求的处理函数
    const activeRequest = debounce(async () => {
      const takedMergeData = mergeData
      const takedRequestList = waitRequestList
      waitRequestList = []
      mergeData = {}
      try {
        const res = await requestApi(takedMergeData)
        takedRequestList.map(request => request.resolve(res))
      } catch(e) {
        takedRequestList.map(request => request.reject(e))
      }
    }, wait, { maxWait })

    // 返回的新的函数
    return (data) => {
      return new Promise((resolve, reject) => {
        mergeData = mergeWith(mergeData, data, customMergeArray)
        waitRequestList.push({ resolve, reject })
        activeRequest()
      })
    }
}


/**
 * 使用方法
 */
// const api = (data) => { console.log('最终进行的请求', data) }
// const newApi = mergeRequest(api)
// let count = 1
// const timer = setInterval(() => {
//   newApi({ count: [(++count).toString()] })
// }, 10)
// setTimeout(() => clearInterval(timer), 1000)
